import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setSelectedPoint = (
  state: MapState,
  action: PayloadAction<MapState['selectedPoint']>
) => {
  state.selectedPoint = action.payload;
}